import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import ATMTransactionInquiryDatatableRowMeta from "@Modules/admin/archiving/containers/mixedHandlers/archivedTables/atmTransactionInquiry/ATMTransactionInquiryDatatableRowMeta";
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TATMTransactionInquiryDataTableData = {
    primaryKey: string | number,
    type: string,
    terminalID: string,
    oneDate: string,
    cardNumber: string,
    serialNumber: string,
    amount: string,
    currency: string,
    status: string,

    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TATMTransactionInquiryDataTableData>()

export function getATMTransactionInquiryDataTableColumns({ isLoading, handleEdit, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("type",
        {
            id: "typeId",
            header: "Type",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("terminalID",
        {
            id: "terminalIDId",
            header: "Terminal ID",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("oneDate",
        {
            id: "oneDateId",
            header: "Date",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("cardNumber",
        {
            id: "cardNumberId",
            header: "N° Carte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("serialNumber",
        {
            id: "serialNumberId",
            header: "Serial N°",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("amount",
        {
            id: "amountId",
            header: "Montant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("currency",
        {
            id: "currencyId",
            header: "Currency",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "statusId",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Details
                        </CustomButton>
                        {/* <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} /> */}
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
